import { Box, Typography, styled } from '@mui/material'
import { FAIRTRADE_FONT_STACK } from 'src/templates/fairtrade/constants'

export const ImpactTitle = styled(Typography)<{ isMobile?: boolean }>(({ theme, isMobile }) => ({
  position: 'relative',
  width: isMobile ? '70%' : '80%',
  marginTop: '90px',
  marginLeft: theme.spacing(1.25),
  fontWeight: 700,
  fontSize: '32px',
  fontFamily: FAIRTRADE_FONT_STACK,
}))

export const ImpactsWrapper = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '48px',
  fontFamily: FAIRTRADE_FONT_STACK,
}))

export const FairtradeImpactCard = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isOdd',
})<{ isOdd: boolean }>(({ theme, isOdd }) => ({
  boxSizing: 'border-box',
  position: 'relative',
  backgroundColor: isOdd ? '#f8f6f4' : '#fff',
  borderRadius: theme.spacing(3),
  padding: '20px',
  boxShadow: '0px 18px 45px rgba(23, 34, 49, 0.08)',
  border: `1px solid rgba(23, 34, 49, 0.05)`,
}))

export const FairtradeImpactTitle = styled(Typography)(({ theme }) => ({
  fontSize: '40px',
  fontWeight: 700,
  marginBottom: '16px',
  color: theme.palette.text.primary,
  fontFamily: FAIRTRADE_FONT_STACK,
}))

export const FairtradeDescriptionWrapper = styled(Box)(({ theme }) => ({
  position: 'relative',
  color: theme.palette.text.primary,
  '&::after': {
    content: '""',
    display: 'block',
    clear: 'both',
  },
}))

export const FairtradeImpactAvatar = styled('img')(({ theme }) => ({
  width: 270,
  height: 270,
  borderRadius: '50%',
  float: 'right',
  marginLeft: '24px',
  marginBottom: '16px',
  objectFit: 'cover',
  shapeOutside: 'circle(50%)',
  [theme.breakpoints.down('md')]: {
    width: 230,
    height: 230,
    marginLeft: '10px',
    marginBottom: '10px',
  },
}))

export const FairtradeDetailsRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'nowrap',
  gap: '10px',
  alignItems: 'start',
  justifyContent: 'space-between',
  marginTop: theme.spacing(3),
}))

export const FairtradeQuantityBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.5),
  minWidth: 140,
}))

export const FairtradeQuantityValue = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  fontSize: '2.25rem',
  lineHeight: 1,
  color: theme.palette.text.primary,
  fontFamily: FAIRTRADE_FONT_STACK,
}))

export const FairtradeQuantityLabel = styled(Typography)(({ theme }) => ({
  textTransform: 'uppercase',
  letterSpacing: '0.08em',
  fontSize: '0.875rem',
  color: theme.palette.text.secondary,
  fontFamily: FAIRTRADE_FONT_STACK,
}))

export const FairtradeMediaWrapper = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(4),
  borderRadius: theme.spacing(2),
  overflow: 'hidden',
}))

export const FairtradeBottomSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2.5),
  marginTop: theme.spacing(3),
}))

export const FairtradeMetaActions = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
}))

export const FairtradeAttachmentsWrapper = styled(Box)(({ theme }) => ({
  borderRadius: theme.spacing(2),
  overflow: 'hidden',
  // backgroundColor: 'rgba(255, 255, 255, 0.7)',
  padding: theme.spacing(1.5),
}))

export const FairtradeHeaderWrapper = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '8px',
  padding: '6px 20px',
}))

export const FairtradeHeaderItem = styled(Box)({
  width: '100%',
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  padding: 0,
  pointerEvents: 'auto',
})

